import { jsx as _jsx } from "react/jsx-runtime";
import styles from './index.module.scss';
var RouteCurrentAnimatedIcon = function () {
    return (_jsx("div", { className: styles.animation }));
};
export default RouteCurrentAnimatedIcon;
